<template>
    <layout title="Online Wires">
        <div class="px-8">
            <div class="flex justify-between items-center mb-4">
                <div class="font-semibold text-lg">
                    Wire History
                </div>

                <add-wire :accounts="accounts"></add-wire>
            </div>
            <wire-listings :wires="items"></wire-listings>
        </div>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import CottonseedListings from "@/Components/CottonseedTickets/CottonseedListings";
import WireListings from "../../Components/Wires/WireListings";
import AddWire from "../../Components/Wires/AddWire";

export default {
    components: {AddWire, WireListings, Layout},
    props: {
        accounts: {
            type: Array,
            default: []
        },
        items: {
            type: Array,
            default: []
        },
    },
}
</script>
